// extracted by mini-css-extract-plugin
export default {"root":"UpdateAssetsWhitelistAction_root__ZXb5s","section":"UpdateAssetsWhitelistAction_section__5Pp7X"};